declare namespace $ {

	export class $shm_hitalama_guide_toggle extends $mol_check_icon {
		Help_icon( ): $mol_icon_help_circle_outline
		section( ): string
		hint( ): string
		Icon( ): ReturnType< $shm_hitalama_guide_toggle['Help_icon'] >
	}
	
}

//# sourceMappingURL=toggle.view.tree.d.ts.map